import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-assigned-routes',
  templateUrl: './assigned-routes.component.html',
  styleUrls: ['./assigned-routes.component.css']
})
export class AssignedRoutesComponent implements OnInit {
public agginData =   
{
  "cabInfo": ["60f66b2e26aa652f099fb284","60f66b4926aa652f099fb285"],
  "routeName": "Route1",
  "branch": "6103ce3fd47110e8d00d9497",
  "routeShift": "6103daacd47110e8d00d94a1",
  "routeTime": {
      "hour": 1,
      "minute": "30",
      "meriden": "PM",
      "format": 12,
      "val": "startData"
  },
  "routeType": "drop",
  "attendance": "1",
  "routeStatus": "1",
  "vehicles": ["60f66b2e26aa652f099fb284","60f66b4926aa652f099fb285"],
  "ivrCalls": "1",
  "employees": ["611226d307434a2d0f3a0bd4","611226d307434a2d0f3a0bd9"],
  "pickupInfo": [

  ],
}


// datas = 60f66b2e26aa652f099fb284:[
//   {
//       "vehicleLocation": {
//           "lat": 13.00268,
//           "lng": 80.21145999999999,
//           "name": "Axis Bank ATM, No 80, Chennai, Tamil Nadu, India"
//       },
//       "title": "PP1",
//       "location": {
//           "lat": 12.987449,
//           "lng": 80.218362,
//           "name": "Subway, Velachery Main Road, Chennai, Tamil Nadu, India"
//       },
//       "ETA": {
//           "hour": "6",
//           "minute": "30",
//           "meriden": "AM",
//           "format": 12
//       },
//       "radius": 200,
//       "status": "true",
//       "employees": null,
//       "attendance": "Wifi"
//   },
//   {
//   "previousLocation": {
//       "lat": 12.987449,
//       "lng": 80.218362,
//       "name": "Subway, Velachery Main Road, Chennai, Tamil Nadu, India"
//   },
//   "title": "PP2",
//   "location": {
//       "lat": 12.981383,
//       "lng": 80.242121,
//       "name": "St Antony's Church, Chennai, Tamil Nadu, India"
//   },
//   "ETA": {
//       "hour": "7",
//       "minute": "30",
//       "meriden": "AM",
//       "format": 12
//   },
//   "radius": 200,
//   "status": "true",
//   "employees": [],
//   "attendance": "Wifi"
//   }
//   ]
//  data2 = [60f66b4926aa652f099fb285 =[{
//   "vehicleLocation": {
//       "lat": 13.00268,
//       "lng": 80.21145999999999,
//       "name": "Axis Bank ATM, No 80, Chennai, Tamil Nadu, India"
//   },
//   "title": "P2",
//   "location": {
//       "lat": 13.001519,
//       "lng": 80.199085,
//       "name": "Asif Brothers Restaurant, Chennai, Tamil Nadu, India"
//   },
//   "ETA": {
//       "hour": "8",
//       "minute": "30",
//       "meriden": "AM",
//       "format": 12
//   },
//   "radius": 300,
//   "status": "true",
//   "employees": [],
//   "attendance": "Beacon"
// }]]
  constructor() { }

  ngOnInit(): void {
  }

}
